import React from 'react'
import Icon from 'components/elements/Icon'
import type { SemanticICONS } from 'semantic-ui-react'

import styles from './bannerButton.module.scss'

type Props = {
  leftContent?: React.ReactNode
  rightContent?: React.ReactNode
  reverseOnMobile?: boolean
}

const BannerControls = ({ leftContent, rightContent, reverseOnMobile }: Props) => {
  return (
    <>
      <div className={styles.scrollContainer}>
        <div className={`${styles.container} ${reverseOnMobile && styles.reverseOnMobile}`}>
          <div className={styles.groups}>{leftContent}</div>

          <div className={`${styles.groups} ${styles.deckControls}`}>{rightContent}</div>
        </div>
      </div>
    </>
  )
}

export default BannerControls

type MenuButtonProps = {
  icon: SemanticICONS | 'edhrec'
  label: string
  onClick?: () => void
  noTextOnSmall?: boolean
  to?: string
  className?: string
  wrappingClassName?: string
}

export const Button = ({
  icon,
  label,
  onClick,
  to,
  className,
  noTextOnSmall,
  wrappingClassName = '',
}: MenuButtonProps) => {
  if (onClick)
    return (
      <span className={`${styles.button} ${wrappingClassName}`}>
        <button onClick={onClick} className={className}>
          {icon !== 'edhrec' && <Icon name={icon} />}
          {icon === 'edhrec' && <img alt="EDHREC" height={14} src="/images/edhrec.svg" />}
          {label && <span className={noTextOnSmall ? styles.hideOnMobile : undefined}>{label}</span>}
        </button>
      </span>
    )

  if (to)
    return (
      <span className={`${styles.button} ${wrappingClassName}`}>
        <a href={to} className={className}>
          {icon !== 'edhrec' && <Icon name={icon} />}
          {label}
        </a>
      </span>
    )

  return null
}
